// extracted by mini-css-extract-plugin
export default {"main-head":"style_main-head__GRvqA","ripple-animation":"style_ripple-animation__6h94g"};